import React from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { useKeycloak } from "./KeycloakProvider";
import getEnv from "./config";

const PrivateRoute = ({ children }) => {
  const { keycloak, initialized, authError } = useKeycloak();
  const AUTH_ENABLED = getEnv("REACT_APP_AUTH_ENABLED") === "true";

  if (!AUTH_ENABLED) return <>{children}</>;

  if (!initialized) {
    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!keycloak?.authenticated) {
    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 2, p: 3 }}>
        <Typography variant="h6">Authentication failed</Typography>
        {authError && (
          <Typography variant="body2" sx={{ maxWidth: 600, wordBreak: "break-all", bgcolor: "#f5f5f5", p: 2, borderRadius: 1 }}>
            {authError}
          </Typography>
        )}
        <Typography variant="body2">Check the browser console (F12) for [KC] logs.</Typography>
        <Button variant="contained" onClick={() => keycloak.login({ redirectUri: window.location.origin + "/" })}>
          Try Login Again
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;
